<template>
  <div class="numberBgc box">
    <div v-if="!cellData"></div>
    <div v-else>
      <!-- isOpen 0-停诊 1-开放 -->
      <div :class="cellData.isOpen === '1' || !cellData.isOpen ? 'open' : 'suspend'">
        <div v-if="cellData.isOpen === '1'" @click="handleClick">
          <div :class="`order ${cellData.surplusCount === '0' && 'grey'}`">预约</div>
          <div>{{ `（余号 ${cellData.surplusCount}）` }}</div>
        </div>
        <div v-if="cellData.isOpen === '0'">停诊</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, ref } from 'vue'
const props = defineProps({
  data: {
    type: Object,
    default: null
  },
  type: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['handleSelect'])

const cellData = ref({})

watch(
  () => props.type,
  val => {
    const { shiftScheduleDate, week, doctorScheduleDayVO } = props.data
    const {
      amAmPmId,
      pmAmPmId,
      amIsOpen,
      pmIsOpen,
      amRegistrationFee,
      pmRegistrationFee,
      amShiftScheduleId,
      pmShiftScheduleId,
      amSurplusCount,
      pmSurplusCount
    } = doctorScheduleDayVO || {}
    cellData.value = doctorScheduleDayVO && {
      amPmId: val === 'am' ? amAmPmId : pmAmPmId,
      isOpen: val === 'am' ? amIsOpen : pmIsOpen,
      registrationFee: val === 'am' ? amRegistrationFee : pmRegistrationFee,
      shiftScheduleId: val === 'am' ? amShiftScheduleId : pmShiftScheduleId,
      surplusCount: val === 'am' ? amSurplusCount : pmSurplusCount,
      shiftScheduleDate,
      week
    }
  },
  { immediate: true }
)

const handleClick = () => {
  const { surplusCount } = cellData.value
  if (surplusCount === '0') return // 余号为0 不可点击
  const selectedData = {
    ...cellData.value,
    amPmId: props.type === 'am' ? '0' : '1' // 上午下午ID 0-上午 1-下午
  }
  console.log(selectedData)
  emit('handleSelect', selectedData)
}
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: 184px;
  height: 58px;
  border-radius: 4px;
  margin: 2px 1px;
  .open {
    cursor: pointer;
  }
}
.titleBgc {
  background-color: #eff4fa;
}
.numberBgc {
  border: 1px solid #f0f0f0;
}
.order {
  color: #1890ff;
  font-size: 14px;
}
.grey {
  color: #d9d9d9;
}
.suspend {
  height: 58px;
  width: 184px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #595959;
  background: url('../../../assets/img/register/suspend.png') no-repeat center;
  background-size: 100% 100%;
}
</style>
